import moment from 'moment'

const today = new Date()

export const formatDate = (date) => {
    return moment(date).format('h:mm A MMM DD, YYYY');
}
